import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RedirectPreloaderService {
  public redirecting = { preloader: false };
}
